import smoothscroll from "smoothscroll-polyfill";

export const smothScrollTo = () => {
    smoothscroll.polyfill();

    let links = document.querySelectorAll('a[href*="#"]:not([href="#"])');

    if (links.length > 0) {
        for (let i = 0; i < links.length; ++i) {
            const link = links[i];
            new SmoothScrollTo(link);
        }
    }
};

function getOffsetTop( elem ){
    var offsetTop = 0;
    do {
      if ( !isNaN( elem.offsetTop ) )
      {
          offsetTop += elem.offsetTop;
      }
    } while( elem = elem.offsetParent );
    return offsetTop;
}


export class SmoothScrollTo {
    /**
     * @type {HTMLLinkElement}
     */
    el;

    clickHandle = (e) => {
        e.preventDefault();

        let hash = this.el.getAttribute("href");
        let target = document.querySelector(hash);
        let headerOffset = 100;
        let elementPosition = getOffsetTop(target);
        let offsetPosition = elementPosition - headerOffset;

        // console.log(target.offsetTop)
        // console.log(getOffsetTop(target))


        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
        });
    };

    /**
     * @param {HTMLLinkElement} el
     */
    constructor(el) {
        this.el = el;
        el.addEventListener("click", this.clickHandle);
    }

    /**
     * @param {HTMLLinkElement} el
     */
    update(el) {}

    /**
     * @param {HTMLLinkElement} el
     */
    destroy(el) {
        el.removeEventListener("click", this.clickHandle);
    }
}
